import React, { useEffect } from 'react';
import formattedCurrency from '../../helpers/currencyFormat';
const ProductPrice = ({ selectedPrice, selectedQty, basePricePerItem, extrasAdded, baseUnitPrice, strings, setBaseCurrentVariantSaving, customClass, }) => {
    const basePrice = basePricePerItem * selectedQty;
    const savingPercentage = ((selectedPrice / basePrice) * 100).toFixed();
    useEffect(() => {
        if (basePrice > selectedPrice) {
            setBaseCurrentVariantSaving(basePrice - selectedPrice);
        }
        else {
            setBaseCurrentVariantSaving(0);
        }
    }, [selectedPrice, basePrice]);
    return (React.createElement("div", { className: `hg-modal__price ${customClass ? customClass : ''}` },
        React.createElement("p", null,
            React.createElement("span", { className: "hg-modal__price--base" }, formattedCurrency(selectedPrice, false)),
            basePrice > selectedPrice ? (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "hg-modal__price--compare" }, formattedCurrency(basePrice, false)),
                React.createElement("span", { className: "hg-modal__price--savings" },
                    "(Save ",
                    100 - Number(savingPercentage),
                    "%)"))) : null),
        extrasAdded ? (React.createElement("p", { className: "hg-modal__price--extra-message" },
            React.createElement("span", { className: "hg-modal__price--extra-message-price" },
                "Includes ",
                formattedCurrency(baseUnitPrice, false),
                " ",
                strings.extra_qty_suffix),
            React.createElement("span", { className: "hg-modal__price--extra-message-caption" }, strings.extra_price_label))) : null));
};
export default ProductPrice;
